/*
 *
 * PushNotifications constants
 *
 */
export var LOAD_PUSH_NOTIFICATIONS_REQUEST = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATIONS_REQUEST';
export var LOAD_PUSH_NOTIFICATIONS_SUCCESS = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATIONS_SUCCESS';
export var LOAD_PUSH_NOTIFICATIONS_FAILURE = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATIONS_FAILURE';
export var CLEAR_PUSH_NOTIFICATIONS_SUCCESS = 'app/PUSH_NOTIFICATIONS/CLEAR_PUSH_NOTIFICATIONS_SUCCESS';
export var DELETE_PUSH_NOTIFICATION_REQUEST = 'app/PUSH_NOTIFICATIONS/DELETE_PUSH_NOTIFICATION_REQUEST';
export var DELETE_PUSH_NOTIFICATION_SUCCESS = 'app/PUSH_NOTIFICATIONS/DELETE_PUSH_NOTIFICATION_SUCCESS';
export var DELETE_PUSH_NOTIFICATION_FAILURE = 'app/PUSH_NOTIFICATIONS/DELETE_PUSH_NOTIFICATION_FAILURE';
export var SEND_PUSH_NOTIFICATION_REQUEST = 'app/PUSH_NOTIFICATIONS/SEND_PUSH_NOTIFICATION_REQUEST';
export var SEND_PUSH_NOTIFICATION_SUCCESS = 'app/PUSH_NOTIFICATIONS/SEND_PUSH_NOTIFICATION_SUCCESS';
export var SEND_PUSH_NOTIFICATION_FAILURE = 'app/PUSH_NOTIFICATIONS/SEND_PUSH_NOTIFICATION_FAILURE';
export var LOAD_PUSH_NOTIFICATION_DATA_REQUEST = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATION_DATA_REQUEST';
export var LOAD_PUSH_NOTIFICATION_DATA_SUCCESS = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATION_DATA_SUCCESS';
export var LOAD_PUSH_NOTIFICATION_DATA_FAILURE = 'app/PUSH_NOTIFICATIONS/LOAD_PUSH_NOTIFICATION_DATA_FAILURE';
export var TEST_PUSH_NOTIFICATION_REQUEST = 'app/PUSH_NOTIFICATIONS/TEST_PUSH_NOTIFICATION_REQUEST';
export var TEST_PUSH_NOTIFICATION_SUCCESS = 'app/PUSH_NOTIFICATIONS/TEST_PUSH_NOTIFICATION_SUCCESS';
export var TEST_PUSH_NOTIFICATION_FAILURE = 'app/PUSH_NOTIFICATIONS/TEST_PUSH_NOTIFICATION_FAILURE';
export var CHANGE_MESSAGE = 'app/PUSH_NOTIFICATIONS/CHANGE_MESSAGE';
export var LOAD_FILES_REQUEST = 'app/PUSH_NOTIFICATIONS/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/PUSH_NOTIFICATIONS/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/PUSH_NOTIFICATIONS/LOAD_FILES_FAILURE';
export var LOAD_GROUPS_REQUEST = 'app/PUSH_NOTIFICATIONS/LOAD_GROUPS_REQUEST';
export var LOAD_GROUPS_SUCCESS = 'app/PUSH_NOTIFICATIONS/LOAD_GROUPS_SUCCESS';
export var LOAD_GROUPS_FAILURE = 'app/PUSH_NOTIFICATIONS/LOAD_GROUPS_FAILURE';
export var LOAD_USERS_REQUEST = 'app/PUSH_NOTIFICATIONS/LOAD_USERS_REQUEST';
export var LOAD_USERS_SUCCESS = 'app/PUSH_NOTIFICATIONS/LOAD_USERS_SUCCESS';
export var LOAD_USERS_FAILURE = 'app/PUSH_NOTIFICATIONS/LOAD_USERS_FAILURE';
export var ARCHIVE_PUSH_NOTIFICATION_REQUEST = 'app/PUSH_NOTIFICATIONS/ARCHIVE_PUSH_NOTIFICATION_REQUEST';
export var ARCHIVE_PUSH_NOTIFICATION_SUCCESS = 'app/PUSH_NOTIFICATIONS/ARCHIVE_PUSH_NOTIFICATION_SUCCESS';
export var ARCHIVE_PUSH_NOTIFICATION_FAILURE = 'app/PUSH_NOTIFICATIONS/ARCHIVE_PUSH_NOTIFICATION_FAILURE';
